import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './occupation.reducer';

export const OccupationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const occupationEntity = useAppSelector(state => state.occupation.entity);
  const loading = useAppSelector(state => state.occupation.loading);
  const updating = useAppSelector(state => state.occupation.updating);
  const updateSuccess = useAppSelector(state => state.occupation.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/occupation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.managersDirectorsOfficials !== undefined && typeof values.managersDirectorsOfficials !== 'number') {
      values.managersDirectorsOfficials = Number(values.managersDirectorsOfficials);
    }
    if (values.professionalOccupations !== undefined && typeof values.professionalOccupations !== 'number') {
      values.professionalOccupations = Number(values.professionalOccupations);
    }
    if (values.associateProfessionalTechnical !== undefined && typeof values.associateProfessionalTechnical !== 'number') {
      values.associateProfessionalTechnical = Number(values.associateProfessionalTechnical);
    }
    if (values.administrativeSecretarial !== undefined && typeof values.administrativeSecretarial !== 'number') {
      values.administrativeSecretarial = Number(values.administrativeSecretarial);
    }
    if (values.skilledTradesOccupations !== undefined && typeof values.skilledTradesOccupations !== 'number') {
      values.skilledTradesOccupations = Number(values.skilledTradesOccupations);
    }
    if (values.caringLeisureService !== undefined && typeof values.caringLeisureService !== 'number') {
      values.caringLeisureService = Number(values.caringLeisureService);
    }
    if (values.salesCustomerService !== undefined && typeof values.salesCustomerService !== 'number') {
      values.salesCustomerService = Number(values.salesCustomerService);
    }
    if (values.processPlantMachineOperatives !== undefined && typeof values.processPlantMachineOperatives !== 'number') {
      values.processPlantMachineOperatives = Number(values.processPlantMachineOperatives);
    }
    if (values.elementaryOccupations !== undefined && typeof values.elementaryOccupations !== 'number') {
      values.elementaryOccupations = Number(values.elementaryOccupations);
    }

    const entity = {
      ...occupationEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...occupationEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.occupation.home.createOrEditLabel" data-cy="OccupationCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.occupation.home.createOrEditLabel">Create or edit a Occupation</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="occupation-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.occupation.geographicLevel')}
                id="occupation-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.occupation.date')}
                id="occupation-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.geography')}
                id="occupation-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.geographyCode')}
                id="occupation-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.totalAllUsualResidents')}
                id="occupation-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.managersDirectorsOfficials')}
                id="occupation-managersDirectorsOfficials"
                name="managersDirectorsOfficials"
                data-cy="managersDirectorsOfficials"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.professionalOccupations')}
                id="occupation-professionalOccupations"
                name="professionalOccupations"
                data-cy="professionalOccupations"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.associateProfessionalTechnical')}
                id="occupation-associateProfessionalTechnical"
                name="associateProfessionalTechnical"
                data-cy="associateProfessionalTechnical"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.administrativeSecretarial')}
                id="occupation-administrativeSecretarial"
                name="administrativeSecretarial"
                data-cy="administrativeSecretarial"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.skilledTradesOccupations')}
                id="occupation-skilledTradesOccupations"
                name="skilledTradesOccupations"
                data-cy="skilledTradesOccupations"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.caringLeisureService')}
                id="occupation-caringLeisureService"
                name="caringLeisureService"
                data-cy="caringLeisureService"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.salesCustomerService')}
                id="occupation-salesCustomerService"
                name="salesCustomerService"
                data-cy="salesCustomerService"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.processPlantMachineOperatives')}
                id="occupation-processPlantMachineOperatives"
                name="processPlantMachineOperatives"
                data-cy="processPlantMachineOperatives"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.occupation.elementaryOccupations')}
                id="occupation-elementaryOccupations"
                name="elementaryOccupations"
                data-cy="elementaryOccupations"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/occupation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OccupationUpdate;
